import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';
import JourneySearchHeader from './JourneySearchHeader';

export default injectIntl(withRouter(JourneySearchHeader));
